class UserProfile {
  static instance = null;
  token = "";
  userInfo = null;

  static getInstance() {
    if (UserProfile.instance === null) {
      UserProfile.instance = new UserProfile();
    }
    return UserProfile.instance;
  }

  getToken = () => this.token;

  setToken = (tokenP) => (this.token = tokenP);

  getUserInfo = () => this.userInfo;

  setUserInfo = (userInfoP) => (this.userInfo = userInfoP);

  getUserRoles = () => this.userInfo?.roles ?? null;

  hasGeneralPermisson = () =>
    this.userInfo?.roles?.includes("ROLE_TMI_INSPECTOR") ?? false;

  hasInspectionShowPermisson = () =>
    this.userInfo?.roles?.includes("ROLE_TMI_BE_INSPECTION_SHOW") ?? false;

  hasInspectionCreatePermisson = () =>
    this.userInfo?.roles?.includes("ROLE_TMI_BE_INSPECTION_CREATE") ?? false;

  hasInspectorShowPermisson = () =>
    this.userInfo?.roles?.includes("ROLE_TMI_BE_INSPECTOR_SHOW") ?? false;

  hasInspectorCreatePermisson = () =>
    this.userInfo?.roles?.includes("ROLE_TMI_BE_INSPECTOR_CREATE") ?? false;

  hasInspectorReportPermisson = () =>
    this.userInfo?.roles?.includes("ROLE_TMI_BE_INSPECTOR_REPORT") ?? false;

  hasEmvRole = () =>
    this.userInfo?.roles?.includes("ROLE_TMI_EMV_ADMIN") ?? false;

  hasSupervisorABMRole = () =>
    this.userInfo?.roles?.includes("ROLE_TMI_SUPERVISOR_ABM") ?? false;
  hasMapsRole = () =>
    this.userInfo?.roles?.includes("ROLE_TMI_MAPS") ?? false;

  hasProvinceMapAccess = () => {
    const province = this.userInfo?.province;
    const provinces = Array.isArray(province) ? province : [province];
    return provinces.some((p) => String(p) === "7");
  };

  canViewMap = () => this.hasMapsRole() || this.hasProvinceMapAccess();
}
export default UserProfile;
